function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Vector2d } from "./Vector2d";

/**
 * Here is a representation of it:
 * ```
 * | a | c | tx|
 * | b | d | ty|
 * | 0 | 0 | 1 |
 * ```
 * 初始值
 * ```
 * | 1 | 0 | 0|
 * | 0 | 1 | 0|
 * | 0 | 0 | 1 |
 * ```
 */
export var Matrix = /*#__PURE__*/function () {
  // private array: Float32Array | null = null;

  /**
   * @param a - x scale
   * @param b - y skew
   * @param c - x skew
   * @param d - y scale
   * @param tx - x translation
   * @param ty - y translation
   */
  function Matrix() {
    var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var d = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var tx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var ty = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    _classCallCheck(this, Matrix);
    /** @default 1 */
    _defineProperty(this, "a", void 0);
    /** @default 0 */
    _defineProperty(this, "b", void 0);
    /** @default 0 */
    _defineProperty(this, "c", void 0);
    /** @default 1 */
    _defineProperty(this, "d", void 0);
    /** @default 0 */
    _defineProperty(this, "tx", void 0);
    /** @default 0 */
    _defineProperty(this, "ty", void 0);
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
    this.tx = tx;
    this.ty = ty;
  }
  _createClass(Matrix, [{
    key: "fromArray",
    value: function fromArray(array) {
      this.a = array[0];
      this.b = array[1];
      this.c = array[3];
      this.d = array[4];
      this.tx = array[2];
      this.ty = array[5];
    }

    /**
     * Sets the matrix properties.
     * @param a - Matrix component
     * @param b - Matrix component
     * @param c - Matrix component
     * @param d - Matrix component
     * @param tx - Matrix component
     * @param ty - Matrix component
     * @returns This matrix. Good for chaining method calls.
     */
  }, {
    key: "set",
    value: function set(a, b, c, d, tx, ty) {
      this.a = a;
      this.b = b;
      this.c = c;
      this.d = d;
      this.tx = tx;
      this.ty = ty;
      return this;
    }

    /**
     * Creates an array from the current Matrix object.
     * @param transpose - Whether we need to transpose the matrix or not
     * @param [out=new Float32Array(9)] - If provided the array will be assigned to out
     * @returns The newly created array which contains the matrix
     */
  }, {
    key: "toArray",
    value: function toArray(transpose, out) {
      // if (!this.array)
      // {
      //     this.array = new Float32Array(9);
      // }

      // const array = out || this.array;
      var array = out || new Float32Array(9);
      if (transpose) {
        array[0] = this.a;
        array[1] = this.b;
        array[2] = 0;
        array[3] = this.c;
        array[4] = this.d;
        array[5] = 0;
        array[6] = this.tx;
        array[7] = this.ty;
        array[8] = 1;
      } else {
        array[0] = this.a;
        array[1] = this.c;
        array[2] = this.tx;
        array[3] = this.b;
        array[4] = this.d;
        array[5] = this.ty;
        array[6] = 0;
        array[7] = 0;
        array[8] = 1;
      }
      return array;
    }

    /**
     * Get a new position with the current transformation applied.
     * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
     */
  }, {
    key: "apply",
    value: function apply(vector) {
      var x = vector.x;
      var y = vector.y;
      var x2 = this.a * x + this.c * y + this.tx;
      var y2 = this.b * x + this.d * y + this.ty;
      return new Vector2d(x2, y2);
    }

    /**
     * Get a new position with the inverse of the current transformation applied.
     * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
     */
  }, {
    key: "applyInverse",
    value: function applyInverse(vector) {
      var id = 1 / (this.a * this.d + this.c * -this.b);
      var x = vector.x;
      var y = vector.y;
      var x2 = this.d * id * x + -this.c * id * y + (this.ty * this.c - this.tx * this.d) * id;
      var y2 = this.a * id * y + -this.b * id * x + (-this.ty * this.a + this.tx * this.b) * id;
      return new Vector2d(x2, y2);
    }

    /**
     * Applies translate
     */
  }, {
    key: "translate",
    value: function translate(x, y) {
      this.tx += this.a * x + this.c * y;
      this.ty += this.b * x + this.d * y;
      return this;
    }

    /**
     * Applies scale
     */
  }, {
    key: "scale",
    value: function scale(x, y) {
      this.a *= x;
      this.d *= y;
      this.c *= x;
      this.b *= y;
      return this;
    }

    /**
     * 二维笛卡尔坐标系中，对于一个正交基是逆时针的
     *
     * 屏幕是左上角起点的相反是顺时针
     * Applies a rotation transformation to the matrix.
     * @param rad - 弧度
     * @returns This matrix. Good for chaining method calls.
     */
  }, {
    key: "rotate",
    value: function rotate(rad) {
      var cos = Math.cos(rad);
      var sin = Math.sin(rad);
      var a1 = this.a;
      var c1 = this.c;
      this.a = a1 * cos - this.b * sin;
      this.b = a1 * sin + this.b * cos;
      this.c = c1 * cos - this.d * sin;
      this.d = c1 * sin + this.d * cos;
      return this;
    }
  }, {
    key: "skew",
    value: function skew(_sx, _sy) {
      return this;
    }
    /**
     * Appends the given Matrix to this Matrix.
     * @param matrix - The matrix to append.
     * @returns This matrix. Good for chaining method calls.
     */
  }, {
    key: "multiply",
    value: function multiply(matrix) {
      var a1 = this.a;
      var b1 = this.b;
      var c1 = this.c;
      var d1 = this.d;
      this.a = matrix.a * a1 + matrix.b * c1;
      this.b = matrix.a * b1 + matrix.b * d1;
      this.c = matrix.c * a1 + matrix.d * c1;
      this.d = matrix.c * b1 + matrix.d * d1;
      this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
      this.ty = matrix.tx * b1 + matrix.ty * d1 + this.ty;
      return this;
    }

    /**
     * Sets the matrix based on all the available properties
     */
  }, {
    key: "invert",
    value:
    // /**
    //  * Prepends the given Matrix to this Matrix.
    //  * @param matrix - The matrix to prepend
    //  * @returns This matrix. Good for chaining method calls.
    //  */
    // prepend(matrix: Matrix): this {
    //     const tx1 = this.tx;
    //
    //     if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1)
    //     {
    //         const a1 = this.a;
    //         const c1 = this.c;
    //
    //         this.a = (a1 * matrix.a) + (this.b * matrix.c);
    //         this.b = (a1 * matrix.b) + (this.b * matrix.d);
    //         this.c = (c1 * matrix.a) + (this.d * matrix.c);
    //         this.d = (c1 * matrix.b) + (this.d * matrix.d);
    //     }
    //
    //     this.tx = (tx1 * matrix.a) + (this.ty * matrix.c) + matrix.tx;
    //     this.ty = (tx1 * matrix.b) + (this.ty * matrix.d) + matrix.ty;
    //
    //     return this;
    // }

    // /**
    //  * Decomposes the matrix (x, y, scaleX, scaleY, and rotation) and sets the properties on to a transform.
    //  * @param transform - The transform to apply the properties to.
    //  * @returns The transform with the newly applied properties
    //  */
    // decompose(transform: Transform): Transform {
    //     // sort out rotation / skew..
    //     const a = this.a;
    //     const b = this.b;
    //     const c = this.c;
    //     const d = this.d;
    //     const pivot = transform.pivot;
    //
    //     const skewX = -Math.atan2(-c, d);
    //     const skewY = Math.atan2(b, a);
    //
    //     const delta = Math.abs(skewX + skewY);
    //
    //     if (delta < 0.00001 || Math.abs(PI_2 - delta) < 0.00001)
    //     {
    //         transform.rotation = skewY;
    //         transform.skew.x = transform.skew.y = 0;
    //     }
    //     else
    //     {
    //         transform.rotation = 0;
    //         transform.skew.x = skewX;
    //         transform.skew.y = skewY;
    //     }
    //
    //     // next set scale
    //     transform.scale.x = Math.sqrt((a * a) + (b * b));
    //     transform.scale.y = Math.sqrt((c * c) + (d * d));
    //
    //     // next set position
    //     transform.position.x = this.tx + ((pivot.x * a) + (pivot.y * c));
    //     transform.position.y = this.ty + ((pivot.x * b) + (pivot.y * d));
    //
    //     return transform;
    // }

    /**
     * Inverts this matrix
     * @returns This matrix. Good for chaining method calls.
     */
    function invert() {
      var a1 = this.a;
      var b1 = this.b;
      var c1 = this.c;
      var d1 = this.d;
      var tx1 = this.tx;
      var n = a1 * d1 - b1 * c1;
      this.a = d1 / n;
      this.b = -b1 / n;
      this.c = -c1 / n;
      this.d = a1 / n;
      this.tx = (c1 * this.ty - d1 * tx1) / n;
      this.ty = -(a1 * this.ty - b1 * tx1) / n;
      return this;
    }

    /**
     * Resets this Matrix to an identity (default) matrix.
     */
  }, {
    key: "identity",
    value: function identity() {
      this.a = 1;
      this.b = 0;
      this.c = 0;
      this.d = 1;
      this.tx = 0;
      this.ty = 0;
      return this;
    }

    /**
     * Creates a new Matrix object with the same values as this one.
     * @returns A copy of this matrix. Good for chaining method calls.
     */
  }, {
    key: "clone",
    value: function clone() {
      var matrix = new Matrix();
      matrix.a = this.a;
      matrix.b = this.b;
      matrix.c = this.c;
      matrix.d = this.d;
      matrix.tx = this.tx;
      matrix.ty = this.ty;
      return matrix;
    }

    /**
     * A default (identity) matrix
     * @readonly
     */
  }], [{
    key: "valueOfTransform",
    value: function valueOfTransform(x, y, pivotX, pivotY, scaleX, scaleY, rotation, skewX, skewY) {
      var a = Math.cos(rotation + skewY) * scaleX;
      var b = Math.sin(rotation + skewY) * scaleX;
      var c = -Math.sin(rotation - skewX) * scaleY;
      var d = Math.cos(rotation - skewX) * scaleY;
      var tx = x - (pivotX * a + pivotY * c);
      var ty = y - (pivotX * b + pivotY * d);
      return new Matrix(a, b, c, d, tx, ty);
    }
  }, {
    key: "IDENTITY",
    get: function get() {
      return new Matrix();
    }
  }]);
  return Matrix;
}();
if (process.env.DEBUG) {
  Matrix.prototype.toString = function toString() {
    return "[@stage/math:Matrix a=".concat(this.a, " b=").concat(this.b, " c=").concat(this.c, " d=").concat(this.d, " tx=").concat(this.tx, " ty=").concat(this.ty, "]");
  };
}